import React, { useState, useEffect } from 'react';
import Collapse from 'react-bootstrap/Collapse';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import SearchContainer from '../SearchContainer/SearchContainer';
import { fetchCart } from '../../hook/cart';
import { changeLocal } from "../../hook/Localization";
import logo from "../../assets/logoSm.png";
import "./Navbar.css";
import enLang from "../../assets/lang.svg"
import arLang from "../../assets/emojione_flag-for-saudi-arabia (1).png";
import { Dropdown } from 'react-bootstrap';
import { loginMethod } from '../../hook/auth';

function Navbar() {
  const [open, setOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { currentLocal } = useSelector((state) => state.currentLocal);
  const userinfo = useSelector((state) => state);
  const cart = useSelector((state) => state.cartReducer.cart);

  useEffect(() => {
    dispatch(fetchCart());
  }, [dispatch]);

  const handleSearch = async (e) => {
    const value = e.target.value;
    setSearchValue(value);

    if (!value) {
      setProducts([]);
      return;
    }

    try {
      const res = await axios.get(
        `https://nanosoft.technology/smile/api/search?query=${value}`
      );
      setProducts(res?.data?.data?.results?.product?.items || []);
    } catch (error) {
      alert(Object.values(error?.response?.data?.errors || {})[0]?.[0] || "Search failed");
    }
  };
  const handleLang = () => { dispatch(changeLocal(currentLocal && currentLocal.language === "English" ? "ar" : "en")); }
  return (
    <>
      <div className='media_query'>
        <div className="mx-3 my-3"


        >
          <div className='d-flex justify-content-between align-items-center'>
            <div className='d-flex  align-items-center'>

<div>
                <div
                onClick={() => setOpen(!open)}
                aria-controls="example-collapse-text"
                aria-expanded={open}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5" />
                </svg>
              </div>
                      <Collapse in={open}
                      >
                <div id="example-collapse-text">
      <div className="w-100 position-relative mt-4">
                <input
                  placeholder={currentLocal?.home?.search || "Search..."}
                  className={
                    currentLocal?.language === "English"
                      ? "w-100 text-start h-100 py-1 py-2"
                      : "w-100 text-end h-100 py-1 px-2"
                  }
                  style={{ height: "40px" }}
                  value={searchValue}
                  onChange={handleSearch}
                />
                <div
                  className={
                    currentLocal?.language === "English"
                      ? "searsh_icon"
                      : "ar_searsh_icon"
                  }
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    fill="currentColor"
                    className="bi bi-search"
                    viewBox="0 0 16 16"
                  >
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 
                  1.398h-.001q.044.06.098.115l3.85 
                  3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 
                  1 0 0 0-.115-.1zM12 
                  6.5a5.5 5.5 0 1 1-11 
                  0 5.5 5.5 0 0 1 11 0" />
                  </svg>
                </div>

                {searchValue && (
                  <div
                    className={
                      currentLocal?.language === "English"
                        ? "search_input"
                        : "ar_search_input"
                    }
                  >
                    <SearchContainer
                      searchkey={searchValue}
                      products={products}
                      categories={categories}
                    />
                  </div>
                )}
              </div>
                    <ul className="m-0 quickLinks mt-4">
                <li className="footer_title">{currentLocal.home.quickLinks}</li>
                <li className="footer_item" onClick={() => {
           navigate('/');
                }}>
                  <p className="mb-1">{currentLocal.home.home}</p>
                </li>
                <li className="footer_item" onClick={() => {
                 navigate('/aboutus');
                }}>
                  <p className="mb-1">{currentLocal.home.aboutus}</p>
                </li>
                <li className="footer_item" onClick={() => {
         navigate('/exchange');
                }
                }>
                  <p className="mb-1">{currentLocal.home.Exchange}</p>
                </li>
                <li className="footer_item" onClick={() => {
         navigate('/privacy');
                }}>
                  <p className="mb-1 ">{currentLocal.home.privacy}</p>
                </li>
                <li className="footer_item" onClick={() => {
         navigate('/Contact');
                }}>
                  <p className="mb-1 ">{currentLocal.home.contactUs}</p>
                </li>
                <li className="footer_item" onClick={() => {
         navigate('/shipping');
                }}>
                  <p className="mb-1 ">{currentLocal.home.shipping}</p>
                </li>
                <li className="footer_item" onClick={() => {
         navigate('/terms');
                }}>
                  <p className="mb-1 ">{currentLocal.home.terms}</p>
                </li>
                <li className="footer_item" onClick={() => {navigate('/Product/Verify')}}>
                  <p className="mb-1 ">{currentLocal.home.VerifyProduct}</p>
                </li>
              </ul>
                              </div>
              </Collapse>
</div>
              <Link to="/">
                <div className={currentLocal.language==="English"?'en_nav_logo_container':"nav_logo_container"}>
                  <img src={logo} alt="Logo" className="w-100" />

                </div>
              </Link>
      
            </div>


            <div
              className={currentLocal.language==="English"?'d-flex en_nav_links_tab justify-content-end':'d-flex nav_links_tab justify-content-end'}>
              <div className="dropdown">

                {userinfo?.auth?.access_token ? (
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="light"
                      id="dropdown-basic"
                      style={{
                        ...(location.pathname !== "/" && { color: "black" }),
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="26"
                        height="26"
                        fill="currentColor"
                        className="bi bi-person"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                      </svg>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item as={Link} to="/account_setting">
                        {currentLocal.home.profile}
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/user/orders">
                        {currentLocal.home.myOrder}
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/user/track_order">
                        {currentLocal.home.trackingNumber}
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/user/addressbook">
                        {currentLocal.home.myAddresses}

                      </Dropdown.Item>

                      <Dropdown.Item
                        onClick={() => {
                          dispatch(loginMethod({
                            data: {},
                            access_token: ""
                          }))
                          navigate("/");
                        }}
                      >
                        {currentLocal.home.logout}
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                ) : (


                  <div
                    style={{ marginTop: '7px' }}
                  >
                    <Link to="/login"
                      style={{
                        ...(location.pathname !== '/' && { color: "#2D103A" })
                      }}
                    >

                      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" className="bi bi-person" viewBox="0 0 16 16">
                        <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                      </svg>
                    </Link>
                  </div>

                )}

              </div>


              <div class=" position-relative dropdown d-flex">
                <Link to={userinfo?.auth?.access_token ? "/cart" : "/login"} style={{ marginTop: '7px' }} className='ms-3'>


                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-cart2" viewBox="0 0 16 16">
                    <path d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5M3.14 5l1.25 5h8.22l1.25-5zM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0m9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0" />
                  </svg>
                </Link>
                {userinfo?.auth?.access_token &&
                  <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    {cart?.items?.[0]?.products.length > 0 ? cart?.items?.[0]?.products.length : 0}
                    <span class="visually-hidden">unread messages</span>
                  </span>
                }
              </div>

              <div>
                <div className="nav-item dropdown mx-3">
                  <Link className="nav-link dropdown-toggle d-flex justify-content-center align-items-center" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <img src={currentLocal && currentLocal.language === "العربيه" ? arLang : enLang} alt="" className="w-75" />

                    {currentLocal.language}
                  </Link>
                  <ul className="dropdown-menu">
                    <li><div className="dropdown-item  d-flex align-items-center" onClick={handleLang}>
                      <img src={currentLocal && currentLocal.language === "العربيه" ? enLang : arLang} alt="" className="w-25 me-2" />

                      {currentLocal && currentLocal.language === "English" ? "العربيه" : "English"
                      }

                    </div></li>
                  </ul>
                </div>




              </div>
            </div>
            <div>

            </div>
          </div>
        </div>

      </div>
      <div className='lg_media_query'>
        <div className="mx-3 my-3">

          <div className='d-flex justify-content-between align-items-center'>
            <div className="nav_logo_container"onClick={()=>{
              navigate("/")
            }}
            style={{cursor:"pointer"}}
            >
              <img src={logo} alt="Logo" className="w-100" />
            </div>


            <div style={{ width: "30%", }}>
              <div className="w-100 position-relative">
                <input
                  placeholder={currentLocal?.home?.search || "Search..."}
                  className={
                    currentLocal?.language === "English"
                      ? "w-100 text-start h-100 py-1 py-2"
                      : "w-100 text-end h-100 py-1 px-2"
                  }
                  style={{ height: "40px" }}
                  value={searchValue}
                  onChange={handleSearch}
                />
                <div
                  className={
                    currentLocal?.language === "English"
                      ? "searsh_icon"
                      : "ar_searsh_icon"
                  }
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    fill="currentColor"
                    className="bi bi-search"
                    viewBox="0 0 16 16"
                  >
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 
                  1.398h-.001q.044.06.098.115l3.85 
                  3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 
                  1 0 0 0-.115-.1zM12 
                  6.5a5.5 5.5 0 1 1-11 
                  0 5.5 5.5 0 0 1 11 0" />
                  </svg>
                </div>

                {searchValue && (
                  <div
                    className={
                      currentLocal?.language === "English"
                        ? "search_input"
                        : "ar_search_input"
                    }
                  >
                    <SearchContainer
                      searchkey={searchValue}
                      products={products}
                      categories={categories}
                    />
                  </div>
                )}
              </div>

              {/* Quick Links */}

            </div>


            <div
              className='d-flex nav_links_tab justify-content-end'>
              <div className="dropdown">

                {userinfo?.auth?.access_token ? (
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="light"
                      id="dropdown-basic"
                      style={{
                        ...(location.pathname !== "/" && { color: "black" }),
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="26"
                        height="26"
                        fill="currentColor"
                        className="bi bi-person"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                      </svg>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item as={Link} to="/account_setting">
                        {currentLocal.home.profile}
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/user/orders">
                        {currentLocal.home.myOrder}
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/user/track_order">
                        {currentLocal.home.trackingNumber}
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/user/addressbook">
                        {currentLocal.home.myAddresses}

                      </Dropdown.Item>

                      <Dropdown.Item
                        onClick={() => {
                          dispatch(loginMethod({
                            data: {},
                            access_token: ""
                          }))
                          navigate("/");
                        }}
                      >
                        {currentLocal.home.logout}
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                ) : (


                  <div
                    style={{ marginTop: '7px' }}
                  >
                    <Link to="/login"
                      style={{
                        ...(location.pathname !== '/' && { color: "#2D103A" })
                      }}
                    >

                      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" className="bi bi-person" viewBox="0 0 16 16">
                        <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                      </svg>
                    </Link>
                  </div>

                )}

              </div>


              <div class=" position-relative dropdown d-flex">
                <Link to={userinfo?.auth?.access_token ? "/cart" : "/login"} style={{ marginTop: '7px' }} className='ms-3'>


                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-cart2" viewBox="0 0 16 16">
                    <path d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5M3.14 5l1.25 5h8.22l1.25-5zM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0m9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0" />
                  </svg>
                </Link>
                {userinfo?.auth?.access_token &&
                  <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    {cart?.items?.[0]?.products.length > 0 ? cart?.items?.[0]?.products.length : 0}
                    <span class="visually-hidden">unread messages</span>
                  </span>
                }
              </div>

              <div>
                <div className="nav-item dropdown mx-3">
                  <Link className="nav-link dropdown-toggle d-flex justify-content-center align-items-center" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <img src={currentLocal && currentLocal.language === "العربيه" ? arLang : enLang} alt="" className="w-75" />

                    {currentLocal.language}
                  </Link>
                  <ul className="dropdown-menu">
                    <li><div className="dropdown-item  d-flex align-items-center" onClick={handleLang}>
                      <img src={currentLocal && currentLocal.language === "العربيه" ? enLang : arLang} alt="" className="w-25 me-2" />

                      {currentLocal && currentLocal.language === "English" ? "العربيه" : "English"
                      }

                    </div></li>
                  </ul>
                </div>




              </div>
            </div>






          </div>



        </div>
      </div>
    </>
    // <div className="mx-3 my-3">
    //   {/* Logo */}
    //   <div className='d-flex justify-content-between align-items-center'>
    //     <div className='nav_logo_container'>
    // <div className="w-100">
    //   <img src={logo} alt="Logo" className="w-100" />
    // </div>

    //       {/* Mobile Menu */}
    //       <div className="media_query">
    //     <div className='media_query_search'>fdskfjs</div>

    //   </div>

    // </div>
  );
}

export default Navbar;
